import { render, staticRenderFns } from "./PasswordRenewForm.vue?vue&type=template&id=035cc108&scoped=true&"
import script from "./PasswordRenewForm.vue?vue&type=script&lang=js&"
export * from "./PasswordRenewForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRenewForm.vue?vue&type=style&index=0&id=035cc108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035cc108",
  null
  
)

export default component.exports